/**
 * date utils
 *
 * @author Shigq
 * @date 2021/11/9 10:45
 */
var moment = require('moment-timezone')

/* todo properties */
moment.locale('zh-cn');
moment.tz.setDefault('Asia/Beijing')

/* todo constant */
var FORMAT_DATE = 'YYYY-MM-DD'
var MODE_DAY = 'day'

/* todo methods */
/**
 * 格式化时间，默认为【YYYY-MM-DD】
 *
 * @param value
 * @param formatString
 * @returns {string}
 */
function formatDate(value, formatString) {
	if (!value) return

	formatString = formatString || FORMAT_DATE

	return moment(value).format(formatString)
}

/**
 * 计算时间差，默认为【天】
 *
 * @param startDate
 * @param endDate
 * @returns {*}
 */
function momentDiff(start, end, mode) {
	start = start || Date.now()
	end = end || Date.now()
	mode = MODE_DAY

	const startDate = moment(start)
	const endDate = moment(end)

	return startDate.diff(endDate, mode)
}


module.exports = {
	formatDate,
	momentDiff,
	moment
}
